import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Image from "./Image";
import { Button } from "primereact/button";
import PriceBlock from "./PriceBlock";
import { useBasket } from "../context/BasketContext";
import { encodeArticleForUrl } from "../helpers/helpers";

function Product({
    item,
    priceStyles,
    defaultImage,
    textStyles = "text-white",
    articleStyles = "text-custom-yellow",
    buttonStyles = "bg-custom-yellow hover:bg-custom-yellow-hover",
}) {
    const navigate = useNavigate();
    const { addToBasket, isInBasket } = useBasket();
    const [isAdded, setIsAdded] = useState(false);

    const inBasket = isInBasket(item?.article);

    const handleProductClick = () => {
        if (item?.article) {
            // Use collection from item if available for optimized fetch
            const collectionPath = item.collection?.toLowerCase() || '';
            const encodedArticle = encodeArticleForUrl(item.article);
            navigate(collectionPath ? `/catalog/${collectionPath}/${encodedArticle}` : `/catalog/${encodedArticle}`);
        }
    };

    const handleButtonClick = (e) => {
        e.stopPropagation();
        if (inBasket) {
            navigate("/basket");
        } else {
            addToBasket(item);
            setIsAdded(true);
            setTimeout(() => setIsAdded(false), 1500);
        }
    };

    return (
        <div
            className="w-full flex justify-start items-center flex-col cursor-pointer"
            onClick={handleProductClick}
            title="Переглянути деталі"
        >
            <Image
                className="object-cover"
                highQualitySrc={item?.image}
                lowQualitySrc={defaultImage}
                alt={item?.imageAlt}
                src={item?.image}
            />

            <div className="w-full flex flex-col justify-between text-base lg:text-[22px] leading-7">
                <div className="flex justify-between items-end">
                    <PriceBlock
                        priceStyles={priceStyles}
                        oldPrice={item.oldPrice}
                        price={item.price}
                    />

                    <div>
                        <span className={`${articleStyles} self-end`}>
                            {item.article}
                        </span>
                    </div>
                </div>

                <span
                    className={`${textStyles} text-justify mt-4 lg:mt-7 font-light`}
                >
                    {item.description}
                </span>
            </div>

            <div className="h-full w-full flex items-end">
                <Button
                    className={`${isAdded ? "!bg-green-500 hover:!bg-green-500" : buttonStyles} text-base lg:text-xl shadow-none w-full py-2 lg:py-4 mt-2 lg:mt-4 transition-all duration-300 transform hover:scale-[1.02] active:scale-95 justify-center`}
                    onClick={handleButtonClick}
                    disabled={isAdded}
                >
                    <i className={`${isAdded ? "pi pi-check" : inBasket ? "pi pi-shopping-bag" : "pi pi-shopping-cart"} mr-2`} />
                    {isAdded ? "Додано!" : inBasket ? "У кошику" : "В кошик"}
                </Button>
            </div>
        </div>
    );
}

export default Product;
